import { Container, Text } from "pixi.js";
import { UpgradeTutorialWhiteTextStyle } from "./styles/UpgradeTutorialWhiteTextStyle";
import { UpgradeTutorialGreenTextStyle } from "./styles/UpgradeTutorialGreenTextStyle";
import { Tooltip } from "by/gamefactory/cityversetycoon/scenes/common/components/Tooltip";
import { MyBuildingsTutorialResourcePackage } from "../../resources/MyBuildingsTutorialResourcePackage";

export class UpgradeTutorialFirstTooltipComponent extends Container {
    private static readonly YOU_NEED_TO_TEXT = "YOU NEED TO";
    private static readonly UPGRADE_TEXT = "UPGRADE";
    private static readonly EACH_ITEM_TEXT = "EACH ITEM";
    private static readonly TIMES_TEXT = "4 TIMES";

    private readonly tutorialResources: MyBuildingsTutorialResourcePackage;

    private tooltip: Tooltip;
    private youNeedToText: Text;
    private upgradeText: Text;
    private eachItemText: Text;
    private timesText: Text;

    public constructor(tutorialResources: MyBuildingsTutorialResourcePackage) {
        super();
        this.tutorialResources = tutorialResources;
        this.build();
        this.layout();
    }

    private build(): void {
        this.tooltip = new Tooltip(this.tutorialResources.assets_tutorials_mybuildings_tutorial_tooltip_2_png, 634, 333);
        this.addChild(this.tooltip);
        this.youNeedToText = new Text(UpgradeTutorialFirstTooltipComponent.YOU_NEED_TO_TEXT, new UpgradeTutorialWhiteTextStyle());
        this.addChild(this.youNeedToText);
        this.upgradeText = new Text(UpgradeTutorialFirstTooltipComponent.UPGRADE_TEXT, new UpgradeTutorialGreenTextStyle());
        this.addChild(this.upgradeText);
        this.eachItemText = new Text(UpgradeTutorialFirstTooltipComponent.EACH_ITEM_TEXT, new UpgradeTutorialWhiteTextStyle());
        this.addChild(this.eachItemText);
        this.timesText = new Text(UpgradeTutorialFirstTooltipComponent.TIMES_TEXT, new UpgradeTutorialGreenTextStyle());
        this.addChild(this.timesText);
    }

    private layout(): void {
        this.youNeedToText.position.set(103, 99);
        this.upgradeText.position.set(356, 99);
        this.eachItemText.position.set(135, 169);
        this.timesText.position.set(349, 169);
    }
}